// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'e79751f9-ab25-46a3-b11c-3dcb14962b28',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'd0e90593-071c-4a6d-a4a4-129a8e3e6599',
      type: 'Sprite',
      name: 'tile',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_blue',
      parent: 'e79751f9-ab25-46a3-b11c-3dcb14962b28'
    },
    {
      id: '4e035bf5-56d2-4b7c-b0dd-141e1837e6c2',
      type: 'Container',
      name: 'player',
      className: '',
      x: 0,
      y: -31,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e79751f9-ab25-46a3-b11c-3dcb14962b28'
    },
    {
      id: 'b8011d66-7c39-4b19-ad28-41b4818e3c49',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '80',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0061d6',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.4,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#0061d6',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e79751f9-ab25-46a3-b11c-3dcb14962b28'
    },
    {
      id: '2ef2b917-1a2f-4ae6-bd89-aafe1df9da8b',
      type: 'Sprite',
      name: '',
      className: 'userAvatar_SPL',
      x: -40,
      y: -105,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '4e035bf5-56d2-4b7c-b0dd-141e1837e6c2'
    },
    {
      id: '62aac6f1-9bc2-4c81-93cf-4b78dbbea7aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Player_Avatar_Frame',
      parent: '4e035bf5-56d2-4b7c-b0dd-141e1837e6c2'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakPlayerLayout {
  static raw = raw;
  root!: Container;
  tile!: Sprite;
  player!: Container;
  levelText!: Text;
  userAvatar_SPL!: (Sprite)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
